import { FormattedEvent } from '@eventbrite/event-renderer';
import { interleaveTwoArrays } from '@eventbrite/event-tracker';
import { getExperiment } from '@eventbrite/statsig';

export enum RelatedEventsSlotsVariants {
    CONTROL = '1',
    SLOTS_1_AND_3 = '1&3',
}

export function getRelatedEventsSlots() {
    const variant = getRelatedEventsSlotsVariant();
    return variant === RelatedEventsSlotsVariants.CONTROL ? 1 : 2;
}

function getRelatedEventsSlotsVariant() {
    const value = getExperiment<
        RelatedEventsSlotsVariants,
        RelatedEventsSlotsVariants
    >(
        'listings_related_events_2_ads_slots',
        'slots',
        RelatedEventsSlotsVariants.CONTROL,
    );

    return value;
}

export function getSortedEvents(
    events: FormattedEvent[],
    promotedEvents: FormattedEvent[],
) {
    const variant = getRelatedEventsSlotsVariant();
    if (variant === RelatedEventsSlotsVariants.CONTROL) {
        return [...promotedEvents, ...events];
    }

    return interleaveTwoArrays(events, promotedEvents as any, [1, 3]);
}
